import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatFooterInfoList } from './footer-info.helper';
import { FooterInfoActions } from './footer-info.redux';
import {
	IPayloadGetFooterInfoListRequest,
	TCreateFooterInfoRequest,
	TPayloadDeleteFooterInfoRequest,
} from './footer-info.type';

export function* getFooterInfoList(
	action: PayloadAction<IPayloadGetFooterInfoListRequest>
) {
	const { isSystemAdmin, unitId, callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.TGetFooterInfoListResponse> =
			yield API.getFooterInfoList({ isSystemAdmin, unitId });
		const footerInfoList = formatFooterInfoList(res?.data);

		yield put(
			FooterInfoActions.getFooterInfoListSuccess({
				footerInfoList,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(FooterInfoActions.getFooterInfoListFailure());
	}
}

export function* createFooterInfo(
	action: PayloadAction<TCreateFooterInfoRequest>
) {
	const { callback, values } = action.payload;

	try {
		yield API.createFooterInfo(values);

		yield put(FooterInfoActions.createFooterInfoSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(FooterInfoActions.createFooterInfoFailure());
	}
}

export function* deleteFooterInfo(
	action: PayloadAction<TPayloadDeleteFooterInfoRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteFooterInfo(ids);

		yield put(FooterInfoActions.deleteFooterInfoSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(FooterInfoActions.deleteFooterInfoFailure());
	}
}
